export class SmartCriteriRicerca {
    dataInizio: string;
    dataFine: string;
    time: string;
    cognome: string;
    lastname: string;
	statopratica: string;
	includeDocuments: string;
	includePratiche: string;
	tipopratica: string;
	naturafascicolo: string;
	tipodocumento: string;
	annoruolo: string;
	numeroruolo: string;
	Numprotocollo: string;
	Provenienza: string;
	Datanotificaattoda: string;
	Datanotificaattoa: string;
	Datadepositoattoda: string;
	Datadepositoattoa: string;
	Tipoesito: string;
	Numeroesito: string;
	Annoesito: string;
	Datadepositoesitoda: string;
	Datadepositoesitoa: string;
}